import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet"
import "leaflet/dist/leaflet.css"
import { defineComponent } from "vue"

// System wide components
defineComponent(LMap)
defineComponent(LMarker)
defineComponent(LTileLayer)

// @vue-leaflet builds the Leaflet map inside an async onMounted hook that awaits
// several dynamic imports (the Leaflet ESM build + the marker images) *before* it
// calls L.map(container). On the first map render those are real network fetches,
// so if the host component unmounts while they're in flight — e.g. the user
// navigates away right after a map mounts — the container ref is already null and
// Leaflet throws "Map container not found." (Sentry LEWARA-FRONTEND-5E).
//
// Warm those exact lazy chunks once, during idle time, so by the time a map mounts
// the imports resolve from cache (microtasks) instead of the network. This shrinks
// the unmount race window from hundreds of milliseconds to near zero. The specifiers
// must match the library's exactly so the bundler resolves them to the same chunks.
function warmLeafletChunks() {
  const swallow = () => {}
  import("leaflet/dist/leaflet-src.esm").catch(swallow)
  import("leaflet/dist/images/marker-icon-2x.png").catch(swallow)
  import("leaflet/dist/images/marker-icon.png").catch(swallow)
  import("leaflet/dist/images/marker-shadow.png").catch(swallow)
}

if (typeof window.requestIdleCallback === "function") {
  window.requestIdleCallback(warmLeafletChunks)
} else {
  setTimeout(warmLeafletChunks, 0)
}
